import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ApiService} from './api.service';
import {WrapperService} from './wrapper.service';
import {ApiConfigService} from '../core/api-config.service';

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [],
	providers: [WrapperService, ApiService, ApiConfigService]
})
export class ApiModule { }



// WEBPACK FOOTER //
// ./src/app/api/api.module.ts